import { Theme } from '@mui/material';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

type ParamsStyleCard = {
    theme?: Theme;
    isDisabled: string;
}

export const BoxBanner = styled(Box)(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    max-width: 100%;
    display: none;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 1.5rem;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: auto;
        display: flex;
        max-width: 14.5rem;
        padding-bottom: 0;
    }
`);

export const Card = styled(Link)(
    ({ theme, isDisabled }: ParamsStyleCard) => `
    height: 8.56rem;
    display: flex;
    border-radius: 10px;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border: 1px solid ${theme?.palette.primary.main};

    cursor: ${isDisabled === 'active' ? 'not-allowed' : 'pointer'};
    opacity: ${isDisabled === 'active' ? '.2' : '1'};

    .SubTitle {
        width: 100%;
        color: white;
        padding: 1.125rem 0 1rem;
        background-color: ${theme?.palette.primary.main};
        border-radius: 0px 0px 8.5px 8.5px;
    }

    svg {
        padding-top: 6px;
        max-width: 6.31rem;
        margin-bottom: -2rem;
    }

    :hover {
        .SubTitle {
            color: ${theme?.palette.primary.main};
            background-color: ${theme?.palette.secondary.main};
        }
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        
    }
`);

export const GridTab = styled(Box)(
    ({ theme }: ParamsStyle) => `
    display: grid;
    grid-template-columns: 50% 43% 7%;

    p {
        font-size: .75rem;
        line-height: 1rem;
        color: ${theme?.palette.grey[400]};
    }

    h6 {
        font-size: .875rem;
        line-height: 1.2;
        align-items: flex-end;
        color: ${theme?.palette.primary.main};
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        
    }
`);

export const LinkExtermal = styled('a')(`
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: white;
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    border: 2px solid #FFFFFF;
    margin-bottom: .9375rem;
    
    svg {
        position: absolute;
        right: 1.25rem;
        height: 1.2rem;
    }
`);
